'use client';

import { JSX, useEffect } from 'react';
import { scan } from 'react-scan';

export function ReactScan(): JSX.Element | null {
	useEffect(() => {
		scan({
			enabled: false,
			showToolbar: false
		});
	}, []);

	return null;
}
